
import { EditableField } from '@models/editable-field';
import { translate } from '@components/i18n';
import moment from 'moment';

export const columns = [
    {
        title: translate('columns.number'),
        dataIndex: 'numero',
        sorter: false,
        width: '10%',
    },
    {
        title: translate('columns.description'),
        dataIndex: 'descricao',
        sorter: false,
        width: '15%',
    },
    {
        title: translate('columns.division'),
        dataIndex: 'divisao',
        sorter: false,
        width: '10%',
    },

    {
        title: translate('columns.createdAt'),
        dataIndex: 'dataCriacao',
        sorter: false,
        width: '12%',
        render: (text) => {
          const date = text ? moment(text).format('DD/MM/YYYY') : undefined
          return (
              <span>
                  {date || '-'}
              </span>
          );
        },
    },
];

export function editableFields({ withRow = false, editable = false, optionsDivisions, optionsItems }): EditableField[] {
    return [
      {
          name: 'divisao',
          label: translate('forms.labels.division'),
          type: 'select',
          span: 24,
          placeholder: translate('forms.labels.division'),
          options: optionsDivisions,
          disabled: !editable,
          rules: [
              {
                  required: true,
                  message: translate('forms.rules.division'),
              },
          ],
      },
      {
        name: 'numeros',
        label: translate('forms.labels.number'),
        type: 'select',
        multiple: true,
        options: optionsItems,
        disabled: !editable,
        span: 24,
        rules: [
          {
            required: true,
            message: translate('forms.rules.obg'),
          },
        ],
      },
    ];
}
